// @/stores/index.ts
import { createPinia } from 'pinia';

const pinia = createPinia();

export { pinia };
export { useAuthStore } from '@/stores/modules/auth';
export { useAuraStore } from '@/stores/modules/aura';
export { useAuraProcessingCostsStore } from '@/stores/modules/auraProcessingCosts';
export { useContactTimelineFilterStore } from '@/stores/modules/contactTimeline';
export { useFilterStore } from '@/stores/modules/filter';
export { useRealtimeReportStore } from '@/stores/modules/realtime';
export { useUiStore } from '@/stores/modules/ui';
